import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as data from './MOCK_DATA.json';
import { LoggingService } from '../../../../shared/services/logging';
import { EfaactDataService } from '../../../efaact.data-service';
import { InvoiceAddressSetup } from './invoice-address-setup.model';

export const entityName = 'InvoiceAddress';
@Injectable({ providedIn: 'root' })
export class InvoiceAddressSetupDataService extends EfaactDataService<InvoiceAddressSetup> {
    mapItems(item: InvoiceAddressSetup): InvoiceAddressSetup {
        return item;
    }
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
    getAll() {
        return of((data as any).default).pipe(
            map(items => items.map(p => this.mapItems(p)))
        );
    }
}
